// extracted by mini-css-extract-plugin
export default {"container":"CardMVSGraf_container__BW8cL","containerCard":"CardMVSGraf_containerCard__DgpCf"};